
{
  "familyId": "STU-FLOWCHART",
  "questions": [
    {
      "id": "STU-FLOWCHART-001",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "multiple_choice",
      "question": "Kijk naar de flowchart. Wat betekent de ruit in het midden?",
      "options": ["Een beslissing (ja of nee)", "Een actie die je moet uitvoeren", "Het begin van het proces", "Het einde van het proces"],
      "correctAnswer": 0,
      "context": "Flowchart-vormen herkennen",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "stu.flowchart-ruit-rechthoek-verward", "label": "Verwart ruit (beslissing) met rechthoek (actie)", "optionIndex": 1 },
          { "id": "stu.flowchart-ruit-start-verward", "label": "Verwart ruit met begin (ovaal)", "optionIndex": 2 },
          { "id": "stu.flowchart-ruit-einde-verward", "label": "Verwart ruit met einde (ovaal)", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "flowchart",
          "showWhen": "always",
          "data": {
            "nodes": [
              { "id": "n1", "shape": "start", "label": "Start" },
              { "id": "n2", "shape": "decision", "label": "Is het antwoord > 10?", "highlight": true },
              { "id": "n3", "shape": "end", "label": "Einde" }
            ],
            "label": "Eenvoudige flowchart"
          }
        }
      ],
      "supportAids": [
        {
          "type": "flowchart",
          "showWhen": "wrong",
          "data": {
            "nodes": [
              { "id": "s1", "shape": "start", "label": "Begin (ovaal)" },
              { "id": "s2", "shape": "action", "label": "Actie (rechthoek)" },
              { "id": "s3", "shape": "decision", "label": "Beslissing? (ruit)", "highlight": true },
              { "id": "s4", "shape": "end", "label": "Einde (ovaal)" }
            ],
            "label": "Alle vormen in een flowchart"
          }
        }
      ],
      "conceptId": "flowchart_ruit",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een ruitvorm in een flowchart betekent altijd een beslissing. Er komen twee pijlen uit: één voor 'ja' en één voor 'nee'. Het proces volgt de pijl die past bij het antwoord.",
        "solutionSteps": [
          "Kijk naar de vorm: het is een ruit",
          "Ruit = beslissing (ja/nee-vraag)",
          "Twee uitgangen: ja-pijl en nee-pijl",
          "Het proces volgt de juiste pijl"
        ],
        "distractorExplanations": {
          "0": "Goed! Een ruit is altijd een beslissing met twee mogelijke uitgangen.",
          "1": "Een actie staat in een rechthoek, niet in een ruit. Onthoud: ruit heeft hoeken die uitsteken — die wijzen naar de ja/nee-pijlen.",
          "2": "Het begin staat in een ovaal (afgeronde rechthoek), niet in een ruit. Onthoud: ovaal = afgerond = begin/einde.",
          "3": "Het einde staat ook in een ovaal, niet in een ruit. Een ruit zit altijd middenin het proces, nooit aan het einde."
        }
      }
    },
    {
      "id": "STU-FLOWCHART-002",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "multiple_choice",
      "question": "Volg de flowchart hieronder. Wat gebeurt er als het NIET regent?",
      "options": ["Je gaat direct naar buiten zonder paraplu", "Je pakt een paraplu", "Je gaat terug naar Start", "Het proces stopt"],
      "correctAnswer": 0,
      "context": "Flowchart volgen bij een beslissing",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.flowchart-beide-paden-gevolgd", "label": "Volgt beide paden tegelijk", "optionIndex": 1 },
          { "id": "stu.flowchart-loop-verondersteld", "label": "Veronderstelt loop die er niet is", "optionIndex": 2 },
          { "id": "stu.flowchart-beslissing-als-einde", "label": "Denkt dat ruit het proces stopt", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "flowchart",
          "showWhen": "always",
          "data": {
            "nodes": [
              { "id": "n1", "shape": "start", "label": "Start" },
              { "id": "n2", "shape": "decision", "label": "Regent het?" },
              { "id": "n3a", "shape": "action", "label": "Pak een paraplu" },
              { "id": "n3b", "shape": "action", "label": "Ga naar buiten" },
              { "id": "n4", "shape": "end", "label": "Einde" }
            ],
            "edges": [
              { "from": "n1", "to": "n2" },
              { "from": "n2", "to": "n3a", "label": "Ja" },
              { "from": "n2", "to": "n3b", "label": "Nee" },
              { "from": "n3a", "to": "n4" },
              { "from": "n3b", "to": "n4" }
            ],
            "label": "Naar buiten gaan"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Flowchart volgen",
            "content": "Volg altijd de pijlen. Bij een beslissing (ruit) kies je de pijl die past bij je antwoord. 'Regent het?' → Nee → volg de nee-pijl naar 'Ga naar buiten'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flowchart_volgen",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Bij een beslissing in een flowchart volg je de pijl die past bij je antwoord. 'Regent het?' → het regent niet → volg de Nee-pijl → 'Ga naar buiten'. De ja-pijl (paraplu pakken) sla je over.",
        "solutionSteps": [
          "Start → kom bij de beslissing 'Regent het?'",
          "Het regent NIET → antwoord = Nee",
          "Volg de Nee-pijl → 'Ga naar buiten'",
          "De Ja-pijl (paraplu) sla je over"
        ],
        "distractorExplanations": {
          "0": "Goed! Bij Nee volg je de Nee-pijl naar 'Ga naar buiten'.",
          "1": "Een paraplu pak je alleen als het WEL regent (Ja-pijl). Bij een beslissing kies je altijd één pad, niet beide.",
          "2": "Terug naar Start zou een lus zijn — die zou je in de flowchart zien staan. Als er geen terugpijl is, ga je niet terug.",
          "3": "Het proces stopt pas bij een 'Einde'-ovaal, niet bij een beslissing. Een ruit heeft altijd twee uitgangen."
        }
      }
    },
    {
      "id": "STU-FLOWCHART-003",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "multiple_choice",
      "question": "Waarvoor gebruik je een flowchart?",
      "options": ["Om de stappen van een proces overzichtelijk weer te geven", "Om getallen met elkaar te vergelijken", "Om delen van een geheel te tonen", "Om veranderingen over tijd te laten zien"],
      "correctAnswer": 0,
      "context": "Het doel van een flowchart",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "stu.flowchart-staafdiagram-verward", "label": "Verwart flowchart met staafdiagram", "optionIndex": 1 },
          { "id": "stu.flowchart-cirkeldiagram-verward", "label": "Verwart flowchart met cirkeldiagram", "optionIndex": 2 },
          { "id": "stu.flowchart-lijndiagram-verward", "label": "Verwart flowchart met lijndiagram", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wanneer een flowchart?",
            "content": "Een flowchart toont de stappen van een proces in volgorde, inclusief beslissingen. Handig voor instructies, recepten, of het uitleggen van een procedure.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flowchart_doel",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Een flowchart maakt de stappen van een proces overzichtelijk. Je ziet de volgorde, de beslissingen en de mogelijke paden. Andere schema's hebben een andere taak.",
        "solutionSteps": [
          "Flowchart = stappen van een proces",
          "Toont volgorde + beslissingen",
          "Anders dan grafieken of diagrammen"
        ],
        "distractorExplanations": {
          "0": "Goed! Een flowchart toont processtappen overzichtelijk.",
          "1": "Getallen vergelijken doe je met een staafdiagram of tabel — niet met een flowchart.",
          "2": "Delen van een geheel toon je met een cirkeldiagram. Een flowchart heeft geen 'taart'-structuur.",
          "3": "Veranderingen over tijd toon je met een lijndiagram. Een flowchart heeft pijlen, geen as met tijd."
        }
      }
    },
    {
      "id": "STU-FLOWCHART-004",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "multiple_choice",
      "question": "In de flowchart zie je een pijl die terugwijst naar een eerdere stap. Wat betekent dit?",
      "options": ["Een herhaling (lus): je herhaalt stappen tot een voorwaarde klopt", "Er is een fout in de flowchart", "Je moet het hele proces opnieuw beginnen", "Het proces is klaar"],
      "correctAnswer": 0,
      "context": "Lus / herhaling in een flowchart",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.flowchart-terugpijl-als-fout", "label": "Denkt dat terugpijl een fout is", "optionIndex": 1 },
          { "id": "stu.flowchart-loop-herstart-alles", "label": "Denkt dat je het hele proces opnieuw start", "optionIndex": 2 },
          { "id": "stu.flowchart-loop-als-einde", "label": "Denkt dat de loop het einde markeert", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "flowchart",
          "showWhen": "always",
          "data": {
            "nodes": [
              { "id": "n1", "shape": "start", "label": "Start" },
              { "id": "n2", "shape": "action", "label": "Oefen 1 keer" },
              { "id": "n3", "shape": "decision", "label": "Snap je het al?" },
              { "id": "n4", "shape": "end", "label": "Klaar!" }
            ],
            "edges": [
              { "from": "n1", "to": "n2" },
              { "from": "n2", "to": "n3" },
              { "from": "n3", "to": "n2", "label": "Nee" },
              { "from": "n3", "to": "n4", "label": "Ja" }
            ],
            "label": "Flowchart met een lus"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lussen in flowcharts",
            "content": "Een pijl die terugwijst maakt een lus (herhaling). Je herhaalt de stappen tot een beslissing een andere uitkomst geeft. Bijvoorbeeld: 'Snap je het al? Nee → oefen nog een keer.'",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flowchart_lus",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Een terugwijzende pijl maakt een lus: stappen worden herhaald tot de beslissing een andere uitkomst geeft. Lussen zijn normaal in flowcharts — geen fout!",
        "solutionSteps": [
          "Terugwijzende pijl = lus (herhaling)",
          "Stappen worden herhaald",
          "Tot de beslissing een andere uitkomst geeft"
        ],
        "distractorExplanations": {
          "0": "Goed! Een terugwijzende pijl is een lus — stappen worden herhaald.",
          "1": "Het is geen fout. Lussen horen er gewoon bij — denk aan 'oefenen tot het lukt'.",
          "2": "Je herhaalt niet het hele proces, alleen de stappen binnen de lus (vaak één of twee).",
          "3": "Het proces is pas klaar bij een 'Einde'-ovaal. Een lus draait juist door."
        }
      }
    },
    {
      "id": "STU-FLOWCHART-005",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "matching",
      "question": "Koppel elke flowchartvorm aan de juiste betekenis.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Ovaal", "right": "Begin of einde" },
          { "left": "Rechthoek", "right": "Actie of stap" },
          { "left": "Ruit", "right": "Beslissing (ja/nee)" },
          { "left": "Pijl", "right": "Richting van het proces" }
        ]
      },
      "context": "Vormen van een flowchart",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "flowchart",
          "showWhen": "always",
          "data": {
            "nodes": [
              { "id": "n1", "shape": "start", "label": "Begin" },
              { "id": "n2", "shape": "action", "label": "Een actie" },
              { "id": "n3", "shape": "decision", "label": "Een vraag?" },
              { "id": "n4", "shape": "end", "label": "Einde" }
            ],
            "label": "De 4 vormen op een rij"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Flowchartvormen",
            "content": "Ovaal = begin/einde. Rechthoek = actie. Ruit = beslissing. Pijl = richting.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flowchart_vormen_match",
      "variantIndex": 5,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Ovaal = begin/einde. Rechthoek = actie/stap. Ruit = beslissing (ja/nee). Pijl = richting van het proces.",
        "solutionSteps": [
          "Ovaal → Begin of einde",
          "Rechthoek → Actie of stap",
          "Ruit → Beslissing (ja/nee)",
          "Pijl → Richting van het proces"
        ]
      }
    },
    {
      "id": "STU-FLOWCHART-006",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "ordering",
      "question": "Zet de stappen van deze flowchart in de juiste volgorde (van Start naar Einde).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Start",
          "Kook water",
          "Is het water aan de kook?",
          "Doe de thee erin",
          "Drink je thee",
          "Einde"
        ],
        "correctOrder": [0, 1, 2, 3, 4, 5]
      },
      "context": "Volgorde van een proces",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "flowchart",
          "showWhen": "always",
          "data": {
            "nodes": [
              { "id": "a", "shape": "start", "label": "Start" },
              { "id": "b", "shape": "action", "label": "Kook water" },
              { "id": "c", "shape": "decision", "label": "Aan de kook?" },
              { "id": "d", "shape": "action", "label": "Doe thee erin" },
              { "id": "e", "shape": "action", "label": "Drink je thee" },
              { "id": "f", "shape": "end", "label": "Einde" }
            ],
            "edges": [
              { "from": "a", "to": "b" },
              { "from": "b", "to": "c" },
              { "from": "c", "to": "b", "label": "Nee" },
              { "from": "c", "to": "d", "label": "Ja" },
              { "from": "d", "to": "e" },
              { "from": "e", "to": "f" }
            ],
            "label": "Thee zetten"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde lezen",
            "content": "Begin bij Start, volg de pijlen, eindig bij Einde. Bij een 'Nee' op de beslissing draai je terug in de lus — maar de hoofdvolgorde gaat van boven naar beneden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flowchart_volgorde",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Volg de flowchart van Start naar Einde: Start → Kook water → Is het water aan de kook? → (Ja) Doe thee erin → Drink je thee → Einde. De lus 'Nee → terug naar koken' herhaalt zich tot het water kookt.",
        "solutionSteps": [
          "1. Start (ovaal)",
          "2. Kook water (actie)",
          "3. Is het water aan de kook? (beslissing)",
          "4. Doe thee erin (Ja-pad)",
          "5. Drink je thee (actie)",
          "6. Einde (ovaal)"
        ]
      }
    },
    {
      "id": "STU-FLOWCHART-007",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "true_false_series",
      "question": "Bekijk de flowchart. Welke uitspraken kloppen?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Als je 18 of ouder bent, krijg je een volwassen-kaartje.", "isTrue": true },
          { "text": "Bij Nee op 'Ben je 18 of ouder?' krijg je toch een volwassen-kaartje.", "isTrue": false },
          { "text": "Een ruit heeft altijd twee uitgangen (Ja en Nee).", "isTrue": true },
          { "text": "Het proces eindigt al bij de beslissing.", "isTrue": false }
        ]
      },
      "context": "Flowchart-uitspraken beoordelen",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "flowchart",
          "showWhen": "always",
          "data": {
            "nodes": [
              { "id": "a", "shape": "start", "label": "Start" },
              { "id": "b", "shape": "decision", "label": "Ben je 18 of ouder?" },
              { "id": "c", "shape": "action", "label": "Kind-kaartje" },
              { "id": "d", "shape": "action", "label": "Volwassen-kaartje" },
              { "id": "e", "shape": "end", "label": "Einde" }
            ],
            "edges": [
              { "from": "a", "to": "b" },
              { "from": "b", "to": "c", "label": "Nee" },
              { "from": "b", "to": "d", "label": "Ja" },
              { "from": "c", "to": "e" },
              { "from": "d", "to": "e" }
            ],
            "label": "Kaartje kopen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Flowchart lezen",
            "content": "Bij elke beslissing volg je één pad. De ruit heeft altijd twee uitgangen, maar je gaat maar één kant op. Het proces stopt pas bij het Einde-ovaal.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flowchart_uitspraken",
      "variantIndex": 7,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bij de Ja-pijl ga je naar 'Volwassen-kaartje', bij Nee naar 'Kind-kaartje'. Een ruit heeft altijd twee uitgangen, maar je volgt er steeds maar één. Het proces stopt pas bij het Einde-ovaal.",
        "solutionSteps": [
          "Uitspraak 1: Ja-pad → volwassen-kaartje ✓",
          "Uitspraak 2: Nee-pad → kind-kaartje (niet volwassen) ✗",
          "Uitspraak 3: ruit heeft 2 uitgangen ✓",
          "Uitspraak 4: einde pas bij ovaal, niet bij ruit ✗"
        ]
      }
    }
  ]
}
